import type { GetCustomizationResponse } from '@api-client/products';
import { logger } from '@luna/logger';
import { getFeatureConfig } from '@luna/feature-config';
import { useActiveProduct } from '@shared/products-core';
import type { Account } from '@shared/products-types';

import { gAPIAccountEntitySlice } from '../../../../gAPIAccountEntitySlice';
import { useActivePAPIProduct } from '../../../../ActivePAPIProductContext';
import { useActiveProductServices } from '../../../../ActiveProductServicesContext';

export const useCustomizationSuccessHandler = () => {
    const { updateCache } = useActiveProductServices();
    const { relyOnGAPIForAggregation } = getFeatureConfig(({ products }) => products);
    const product = useActivePAPIProduct();
    const { id } = useActiveProduct<Account>();

    return (customizationResponse: GetCustomizationResponse) => {
        const customizationView = customizationResponse._embedded?.['customization-view'];

        if (!customizationView) {
            logger.error('missing customization-view object in response');
            return;
        }

        if (relyOnGAPIForAggregation) {
            const gapiAccount = gAPIAccountEntitySlice.selectById(id);
            gAPIAccountEntitySlice.updateCache({
                ...gapiAccount,
                alias: customizationView.name,
                additionalData: {
                    ...gapiAccount?.additionalData,
                    hidden: customizationView.hiddenOnOverview,
                    color: customizationView.color.id ?? '',
                } as Account['additionalData'],
            } as Account);
        }

        updateCache({
            ...product,
            _embedded: { ...product._embedded, customization: customizationView },
        });
    };
};
